import {
  formatMoneyMinor,
  minorToInput as sharedMinorToInput,
  parseMoneyToMinor as sharedParse,
} from '@optiflow/shared';
import type { SupportedLocale } from '@optiflow/types';

/**
 * Money for the browser.
 *
 * The arithmetic lives in `@optiflow/shared` so the API and the UI cannot disagree about what a
 * price is; this module only adds the locale, which is a purely presentational concern.
 *
 * Every function takes the currency explicitly. There is no default: a tenant keeping its books in
 * Kuwaiti dinars has three decimal places, and a helpful-looking fallback to two is exactly how a
 * price ends up wrong by a factor of ten.
 */

const LOCALE_TAG: Record<SupportedLocale, string> = { en: 'en-GB', ar: 'ar-EG' };

export function formatMoney(
  minor: number | null | undefined,
  locale: SupportedLocale,
  currencyCode: string,
): string {
  return formatMoneyMinor(minor, currencyCode, LOCALE_TAG[locale]);
}

export function parseMoneyToMinor(value: string, currencyCode: string): number | null {
  return sharedParse(value, currencyCode);
}

export function minorToInput(minor: number | null | undefined, currencyCode: string): string {
  return sharedMinorToInput(minor, currencyCode);
}
